import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { availabilityShape, bibShape, childrenShape } from '@bibliocommons/bc-prop-types';
import AvailabilityStatus from '@bibliocommons/availability-status';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { bindAll } from '@bibliocommons/utils-react';
import { SecondaryTextButton } from '@bibliocommons/base-buttons';

import { AvailabilityDetailsContainer } from 'app/components/bibs/shared/AvailabilityDetails';
import { FullScreenOverlayContainer } from 'app/components/shared/FullScreenOverlay';
import { MATERIAL_TYPE_PHYSICAL } from 'app/constants/BibConstants';

export default class AvailabilityDetailsButton extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);

    this.state = {
      open: false
    };
  }

  handleOpen() {
    const { handleButtonClick } = this.props;

    if (typeof handleButtonClick === 'function') {
      handleButtonClick();
    }

    this.setState({ open: true });
  }

  handleClose() {
    this.setState({ open: false });
  }

  renderContent() {
    const { bib, availability } = this.props;
    const format = bib.getIn(['briefInfo', 'format']);

    return (
      <span>
        <span aria-hidden="true">
          <FormattedMessage id="Availability.detailsLink" />
        </span>
        <ScreenReaderMessage>
          <FormattedMessage
            id="Availability.ada_detailsLink"
            values={{
              title: bib.getIn(['briefInfo', 'title']),
              format: <FormattedMessage id={`FORMAT.${format.toLowerCase()}`} />,
              status: (
                <AvailabilityStatus
                  rollUpStatus={availability.get('statusType')}
                  status={availability.get('localisedStatus')}
                  availabilityLocationType={availability.get('availabilityLocationType')}
                />
              )
            }}
          />
        </ScreenReaderMessage>
      </span>
    );
  }

  render() {
    const { bib, ButtonComponent, children } = this.props;
    const Button = ButtonComponent || SecondaryTextButton;
    const materialType = bib.getIn(['policy', 'materialType']);

    return materialType === MATERIAL_TYPE_PHYSICAL ? (
      <div className="cp-availability-details-button">
        <Button dataKey="cp-availability-details-button" handleClick={this.handleOpen}>
          {children || this.renderContent()}
        </Button>
        <FullScreenOverlayContainer
          open={this.state.open}
          handleClose={this.handleClose}
          overlayKey="availability-details-full-screen-overlay"
          dataKey="availability-details-full-screen-overlay"
        >
          {this.state.open && <AvailabilityDetailsContainer metadataId={bib.get('id')} />}
        </FullScreenOverlayContainer>
      </div>
    ) : null;
  }
}

AvailabilityDetailsButton.propTypes = {
  availability: availabilityShape.isRequired,
  bib: bibShape.isRequired,
  ButtonComponent: PropTypes.func,
  children: childrenShape,
  handleButtonClick: PropTypes.func
};
